import BoxConfig from "../components/BoxConfig"


export default function ShipPage({ user})
{

return (
  <div className="App" id="main-bg">
    <main>
    <section id="core-concepts">
        <h2>Ship</h2>

      </section>
    </main>

  <main>
    <section id="box-dimensions">
    <BoxConfig user ={user}/>
   
    </section>
  </main>



  </div>
);

  }

